export default {
    title: "Verificação do endereço",
    header: "@:views.address.verified.title",
    message: " Obrigado por verificar seu endereço. Agora você pode definir este como endereço de entrega ao fazer um pedido.",
}